/**
 * Created by razial on 17.09.2026
 */

const ControlButtons = {
    list: [
        SwitchAdminButton,
        ExitControlButton,
        FullscreenControlButton,
        MenuControlButton,
        PauseControlButton
    ]
};
